import IndustryDetail from '@/components/feature/IndustryDetail';
import { industriesData } from '@/mocks/industryDetails';

export default function Education() {
  return <IndustryDetail data={industriesData.education} />;
}